/**
 * Uygulama genelinde MUI yüzeylerinde gölge kullanılmaz; kart/paper için mobil ile aynı hafif gri çerçeve.
 * Renk: e-doctor-mobile `primary.colors.border.main` (#E2E8F0)
 */
import { formSurfaceBorder } from "./theme";

const shadowResetGlobalStyles = {
    ".MuiButton-root, .MuiButton-root:hover, .MuiButton-root:active": {
        boxShadow: "none !important",
    },
    ".MuiIconButton-root, .MuiIconButton-root:hover": {
        boxShadow: "none !important",
    },
    ".MuiFab-root": {
        boxShadow: "none !important",
    },
    ".MuiToggleButton-root, .MuiToggleButton-root:hover": {
        boxShadow: "none !important",
    },
    ".MuiCard-root": {
        boxShadow: "none !important",
        border: `${formSurfaceBorder} !important`,
        borderRadius: "12px !important",
    },
    ".MuiPaper-root": {
        boxShadow: "none !important",
        backgroundImage: "none !important",
        border: `${formSurfaceBorder} !important`,
        borderRadius: "12px !important",
    },
    ".MuiPaper-root.MuiAppBar-root, .MuiPaper-root.MuiDrawer-paper": {
        border: "none !important",
        borderRadius: "0 !important",
    },
    ".MuiAppBar-root": {
        boxShadow: "none !important",
    },
    ".MuiDialog-paper": {
        boxShadow: "none !important",
        border: `${formSurfaceBorder} !important`,
        borderRadius: "12px !important",
    },
    ".MuiPopover-paper, .MuiMenu-paper": {
        border: `${formSurfaceBorder} !important`,
        borderRadius: "8px !important",
    },
    ".MuiDrawer-paper": {
        boxShadow: "none !important",
    },
    ".MuiAccordion-root": {
        boxShadow: "none !important",
        border: `${formSurfaceBorder} !important`,
    },
};

export default shadowResetGlobalStyles;
